const searchFilter = (input, data) =>
  data.filter(
    (inv) =>
      inv.caregiverName.toLowerCase().includes(input.toLowerCase()) ||
      inv.patientName.toLowerCase().includes(input.toLowerCase())
  )

export default searchFilter
